import { render, staticRenderFns } from "./CreateSheet.vue?vue&type=template&id=71b3bcd8&scoped=true&"
import script from "./CreateSheet.vue?vue&type=script&lang=js&"
export * from "./CreateSheet.vue?vue&type=script&lang=js&"
import style0 from "./CreateSheet.vue?vue&type=style&index=0&id=71b3bcd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3bcd8",
  null
  
)

export default component.exports